import Vue from "vue";
// vant
import "@/utils/UI";
// 覆盖Vant样式
import "@/style/common/coverUI.less";
// Muse
import 'muse-ui/lib/styles/base.less';
import 'muse-ui/lib/styles/theme.less';
import 'muse-ui-progress/dist/muse-ui-progress.css';
import 'muse-ui-loading/dist/muse-ui-loading.css';
import NProgress from 'muse-ui-progress';
import Helpers from 'muse-ui/lib/Helpers';
import Loading from 'muse-ui-loading';
import Toast from 'muse-ui-toast';
import {
    Button as van_Button,
    CountDown,
    Icon as van_icon,
    form as van_form,
    Cell,
    Field,
    DatetimePicker,
    Picker,
    Popup,
    Collapse,
    CollapseItem,
    RadioGroup,
    Radio as van_radio,
    uploader,
    Dialog,
    ImagePreview,
    calendar,
    overlay,
    Image as VanImage,
    Swipe,
    SwipeItem,
    Lazyload,
    PullRefresh,
    Checkbox,
    CheckboxGroup,
    CellGroup,
    divider
} from 'vant';

import {
    Icon,
    Button,
    Form,
    TextField,
    Progress,
    BottomNav,
    Grid,
    Tabs,
    Radio,
    Snackbar,
    Badge,
    BottomSheet,
    LoadMore,
    Drawer
} from 'muse-ui';

Vue.use(Button)
    .use(Radio)
    .use(calendar)
    .use(Drawer)
    .use(NProgress)
    .use(Badge)
    .use(BottomSheet)
    .use(Loading)
    .use(LoadMore)
    .use(Progress)
    .use(Helpers)
    .use(TextField)
    .use(Form)
    .use(BottomNav)
    .use(Icon)
    .use(Tabs)
    .use(Grid)
    .use(Snackbar)
    .use(VanImage)
    .use(Swipe)
    .use(SwipeItem)
    .use(Lazyload)
    .use(PullRefresh)
    .use(divider)
    .use(Toast,{
        time: 2000
    })
    // vant
    .use(uploader)
    .use(overlay)
    .use(ImagePreview)
    .use(Dialog)
    .use(RadioGroup)
    .use(van_radio)
    .use(Collapse)
    .use(CollapseItem)
    .use(van_form)
    .use(Field)
    .use(Picker)
    .use(Popup)
    .use(DatetimePicker)
    .use(Cell)
    .use(Checkbox)
    .use(CheckboxGroup)
    .use(CellGroup)
    .use(CountDown)
    .use(van_Button)
    .use(van_icon);


Vue.prototype.$toast = Toast;
Vue.prototype.$ImagePreview = ImagePreview;
